// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"header_flex__ZExkp","container":"header_container__Pg3wx","pulse":"header_pulse__0W4Wd"};